/* eslint-disable no-nested-ternary */
// @flow
import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import CardTable from '../CardTable/CardTable';
import LastTable from '../LastTable/LastTable';
import Card from '../../components/Card';
import BreadCrumbs from '../../components/BreadCrumbs';
import Switch from '../../components/Switch/switch';
import Toggler from '../../components/Toggler';
import { P } from '../../components/Typography';
import Preloader from '../../components/Preloader';
import SituationTable from '../CombinationTable/CombinationTable';
import useWindowDimensions from '../../utils/windowDemensions';
import { getBreakpoints, MATRIX as matrixBreakpoints } from '../../utils/breakpoints';
import PressButton from 'components/PressButton/PressButton';

type Props = {
  // for situation table
  situation: Array<{
    id: number,
    x: number,
    y: number,
    name: string,
    type: string,
    bb: string,
    ts: string,
    color: string,
  }> | undefined,
  isSituationLoading: boolean,
  selectedTs: string,
  rate?: boolean,
  selectedBB: string,
  selectedTable: number,
  selectedStake: string,
  selectedCards: string,
  setSelectedTable: (number) => void,
  setTableData: (Array<any>) => void,
  setBB: () => void,
  setStake: () => void,
  // for card table
  setCard1: (string) => void,
  setCard2: (string) => void,
  setCard3: (string) => void,
  setCard4: (string) => void,
  setTable: (any) => void,
  bbAndStake: string,
  firstPairCardTableFold: Array<any>,
  secondPairCardTableFold: Array<any>,
  setFirstPairCardTableFold: () => void,
  setSecondPairCardTableFold: () => void,
  isFirstPairCardTableFoldLoaded: boolean,
  isSecondPairCardTableFoldLoaded: boolean,
  // for last table
  isTableLoaded: boolean,
  combination: Array<any>,
  // for suit
  suit: string,
  setSuit: (string) => void,
  setSuitQuality: (string) => void,
  initTable: (
    {
      isTrial: boolean,
      ts: string,
      selectedBB: string,
      gameTable: string,
    }
    ) => void,
  changeTs: () => void,
  // setBBNoReplace: () => void,
  easyRFI: boolean,
  setEasyRFI: () => void,
  isPlo5: boolean,
  gameTable: string,
  highestCard?: string,
  suitQuality?: string,
  smartRange?: boolean,
  setSmartRange: () => void,
  ggps: string,
  setGgps: (string) => void,
  sideAction?: React$Node,
  // for last table
}

const tsSelectorOptions = [
  { label: 'Low', value: 'low' },
  { label: 'Med', value: 'medium' },
  { label: 'Med+', value: 'high' },
  { label: 'High', value: 'high_plus' },
  // { label: 'MTT POT', value: 'mttpot' },
  // { label: 'MTT 2.25', value: 'mtt2_25x' },
  // { label: 'HU', value: 'hu' },
];

const tsSelectorOptions6MaxPlo5 = [
  { label: 'Low', value: 'low' },
  { label: 'High', value: 'high' },
  { label: 'ANTE POT', value: 'ante' },
  { label: 'ANTE 3.5', value: 'ante3_5x' },
  // { label: 'Straddle', value: 'straddle' },
  // { label: 'Straddle 3x', value: 'straddle3x' },
];

const tsSelectorOptionsHUPlo5 = [
  { label: 'Low', value: 'low' },
  { label: 'Med', value: 'medium' },
  { label: 'High', value: 'high' },
];

const tsSelectorOptionsGG = [
  { label: 'Low', value: 'low' },
  { label: 'High', value: 'high' },
];

const tsSelectorOptionsMTT = [
  { label: 'MTT POT', value: 'mttpot' },
  { label: 'MTT 2.25', value: 'mtt2_25x' },
  { label: 'MTT ANTE POT', value: 'mttpot_ante' },
  { label: 'MTT ANTE 2.5', value: 'mttx25_ante' },
];

const tsSelectorOptionsHU = [
  { label: 'HU', value: 'hu' },
];

const extraBottomButtonsEP = [
  {
    label: 'EP vs SQZ GENERAL',
    value: 'epvssqz',
  },
  {
    label: 'EP vs MP+SB SQZ',
    value: 'epvssqzmp+sb',
  },
  {
    label: 'EP vs MP+CO SQZ',
    value: 'epvssqzmp+co',
  },
  {
    label: 'EP vs CO+BU SQZ',
    value: 'epvssqzco+bu',
  },
  {
    label: 'EP vs BU+SB SQZ',
    value: 'epvssqzbu+sb',
  },
  {
    label: 'EP vs SB+BB SQZ',
    value: 'epvssqzsb+bb',
  },
];

const extraBottomButtonsMP = [
  {
    label: 'MP vs SQZ GENERAL',
    value: 'mpvssqz',
  },
  {
    label: 'MP vs CO+SB SQZ',
    value: 'mpvssqzco+sb',
  },
  {
    label: 'MP vs CO+BU SQZ',
    value: 'mpvssqzco+bu',
  },
  {
    label: 'MP vs BU+SB SQZ',
    value: 'mpvssqzbu+sb',
  },
  {
    label: 'MP vs SB+BB SQZ',
    value: 'mpvssqzsb+bb',
  },
];

const MatrixTable = ({
  rate = false,
  // for situation table
  situation = [],
  isSituationLoading,
  suit,
  selectedTs,
  selectedBB,
  selectedTable,
  setSelectedTable,
  setTableData,
  selectedStake,
  selectedCards,
  setStake,
  // for card table
  setCard1,
  setCard2,
  setCard3,
  setCard4,
  setTable,
  bbAndStake,
  firstPairCardTableFold,
  secondPairCardTableFold,
  setFirstPairCardTableFold,
  setSecondPairCardTableFold,
  isFirstPairCardTableFoldLoaded,
  isSecondPairCardTableFoldLoaded,
  // for last table
  isTableLoaded,
  combination,
  // for rainbow,
  setSuit,
  setSuitQuality,
  setBB,
  initTable,
  changeTs,
  easyRFI,
  setEasyRFI,
  isPlo5,
  gameTable,
  highestCard,
  suitQuality,
  smartRange,
  setSmartRange,
  ggps,
  setGgps,
  sideAction,

}: Props) => {
  const percentsQ = {
    ip: {
      fold: 0,
      call: 0,
      raise: 0,
    },
    oop: {
      fold: 0,
      call: 0,
      raise: 0,
    },
    easy: {
      fold: 0,
      call: 0,
      raise: 0,
    },
  };
  const [percents, setPercents] = useState<string>(percentsQ);
  const [extraPercents, setExtraPercents] = useState<string>('');
  const [showPercents, setShowPercents] = useState<boolean>(true);
  const handleRainbow = async (): void => {
    await setSuit(suit === 'rainbow' ? 'single' : 'rainbow');
    await setTable();
  };

  const handleMono = async (): void => {
    await setSuit(suit === 'mono' ? 'single' : 'mono');
    await setTable();
  };

  const initTableTrial = () => {
    initTable({
      ts: 'medium', isTrial: rate, selectedBB, gameTable,
    });
  };

  useEffect(() => {
    initTable({
      ts: 'low', isTrial: rate, selectedBB, gameTable,
    });
  }, []);

  React.useEffect(() => {
    if (rate) {
      initTableTrial();
    }
  }, [rate]);

  const filterSitForBB = (arr = []) => {
    const sitArr = [];
    for (let i = 0; i < arr.length; i += 1) {
      if (sitArr.indexOf(arr[i].bb) === -1) {
        sitArr.push(arr[i].bb);
      }
    }
    return sitArr.sort((a, b) => a.split(/ /)[0].replace(/[^\d]/g, '') - b.split(/ /)[0].replace(/[^\d]/g, ''));
  };

  const filterSit = (arr, string) => arr.filter((item) => item.bb === string);

  const changeTableData = (value) => {
    if (isPlo5) {
      initTable({
        ts: selectedTs, isTrial: rate, selectedBB: value.label, gameTable, isBBchanged: true,
      });
      setTableData(situation);
      setBB(value.label);
    } else {
      setTableData(value.value);
      setBB(value.label);
    }
  };

  const changeGameTableHandler = (value) => {
    // setGameTable(value);
    setTableData(value);
    initTable({
      ts: selectedTs, isTrial: rate, selectedBB, gameTable: value, isGameTableChanged: true,
    });
  };

  const handleBBName = (name: string) => {
    if (!name) return 'hu';
    const Reg61 = new RegExp('^.*[^A-zА-яЁё].*$');
    const newName = name.split('');
    const characterArray = [];
    for (let i = 0; i < newName.length; i += 1) {
      if (!(Reg61.test(newName[i]))) {
        break;
      }
      characterArray.push(newName[i]);
    }
    return characterArray.join('') || 'hu';
  };

  const selectedCardsAreUniq = () => {
    const iterable = [selectedCards[0], selectedCards[1], selectedCards[2], selectedCards[3]];
    return new Set(iterable).size === 4;
  };

  const asyncOptions = filterSitForBB(situation).map((item) => (
    { value: filterSit(situation, item), label: handleBBName(item) }
  ));

  const changeTsHandler = (e) => {
    changeTs(e);
    setSelectedTable(1);
    setTableData([]);
    setBB('');
  };

  const changeGgpsHandler = (e) => {
    setGgps(e);
    setSelectedTable(1);
    initTable({
      ts: selectedTs, isTrial: rate, selectedBB, gameTable, ggps: e, isGameTableChanged: true,
    });
  };

  const situationFilterByBB = () => {
    if (isPlo5) return situation;
    return situation.filter((item) => (item.bb?.replace('bb', '') === selectedBB));
  };

  const tsSelectorToggler = (ts) => {
    if (isPlo5) {
      return [
        { label: '20', value: '20' },
        { label: '50', value: '50' },
        { label: '75', value: '75' },
        { label: '100', value: '100' },
      ];
    }
    if (ts === 'medium') {
      return asyncOptions;
    }
    if (ts === 'high' && ggps === 'gg') {
      return asyncOptions;
    }
    if (ts === 'high') {
      return asyncOptions
        .filter((item) => item.label !== '10')
        .filter((item) => item.label !== 'hu');
    }
    if (ts === 'high_plus') {
      return asyncOptions
        .filter((item) => item.label !== '200');
    }
    if (ts === 'low') {
      return asyncOptions;
    }
    if (ts === 'mttpot') {
      return [
        { label: '10', value: '10' },
        { label: '20', value: '20' },
        { label: '30', value: '30' },
        { label: '40', value: '40' },
        { label: '50', value: '50' },
      ];
    }
    if (ts === 'mtt2_25x') {
      return [
        { label: '20', value: '20' },
        { label: '30', value: '30' },
        { label: '40', value: '40' },
        { label: '50', value: '50' },
      ];
    }
    if (ts === 'mttpot_ante') {
      return [
        { label: '10', value: '10' },
        { label: '20', value: '20' },
        { label: '30', value: '30' },
        { label: '40', value: '40' },
        { label: '50', value: '50' },
      ];
    }
    if (ts === 'mttx25_ante') {
      return [
        { label: '10', value: '10' },
        { label: '20', value: '20' },
        { label: '30', value: '30' },
        { label: '40', value: '40' },
        { label: '50', value: '50' },
      ];
    }
    if (ts === 'hu') {
      return asyncOptions;
    }
    return asyncOptions.slice(0, asyncOptions.length - 3);
  };

  const { width } = useWindowDimensions();

  const handlerPercentsOptions = (percentsOptions) => {
    if (!percentsOptions) return null;
    const options = Object.entries(percentsOptions);
    const optionsFilter = options.filter((e) => e[1] > 0);
    return optionsFilter.map((e) => {
      if (!e[0] || !e[1]) return <></>;
      const newStr = e[0][0].toUpperCase() + e[0].slice(1);
      return (
        <>
          <div className={styles.percentsOptionName}>{`${newStr}: `}</div>
          <div className={styles.percentsValue}>{`${e[1]}%`}</div>
        </>
      );
    });
  };

  // eslint-disable-next-line consistent-return
  const getTsSelectorOptions = () => {
    if (!isPlo5 && ggps === 'gg') return tsSelectorOptionsGG;
    if (!isPlo5 && ggps === 'mtt') return tsSelectorOptionsMTT;
    if (!isPlo5 && ggps === 'hu') return tsSelectorOptionsHU;
    if (!isPlo5) return tsSelectorOptions;
    if (isPlo5 && gameTable === '6max') return tsSelectorOptions6MaxPlo5;
    if (isPlo5 && gameTable === 'hu') return tsSelectorOptionsHUPlo5;
    return tsSelectorOptions6MaxPlo5;
  };

  const HandlerPercents = ({ percentsOptions }: any) => {
    if (!percentsOptions) return null;
    if (!showPercents) return null;

    const ip = handlerPercentsOptions(percentsOptions.ip);
    const oop = handlerPercentsOptions(percentsOptions.oop);
    const easyP = handlerPercentsOptions(percentsOptions.easy);
    const isIp = ip.length === 0;
    const isOop = oop.length === 0;
    const isEasy = easyP.length > 0;
    return (
      <div className={styles.percents}>
        {
          (isEasy && easyRFI) ? (
            <div className={styles.percentsWrapper}>
              <span className={styles.percentsTitle}>Easy</span>
              {easyP}
            </div>
          ) : (
            <>
              { ip.length > 0 ? (
                <div className={styles.percentsWrapper}>
                  <span className={styles.percentsTitle}>{isOop ? '' : 'IP'}</span>
                  {ip}
                </div>
              ) : null }
              { oop.length > 0 ? (
                <div className={styles.percentsWrapper}>
                  <span className={styles.percentsTitle}>{isIp ? '' : 'OOP'}</span>
                  {oop}
                </div>
              ) : null }
            </>
          )
        }
      </div>
    );
  };

  const handlePercentShow = (value) => {
    const perc = situationFilterByBB().filter((el) => el.type === value)[0];
    setExtraPercents(percents);
    setPercents(perc?.percents);
  };

  const conditionToShowExtraButton = (epButtons, mpButtons) => {
    if (isPlo5) return false;
    if (selectedTs === 'low' && selectedBB === '200') return false;
    if (selectedTs === 'medium' && selectedBB === '200') return false;
    if (selectedTs === 'mtt2_25x') return false;

    if (selectedTable === 2) {
      if (epButtons.includes(selectedStake) || mpButtons.includes(selectedStake)) {
        return true;
      }
    }
    return false;
  };

  const extraButtonsHandler = () => {
    const epButtons = extraBottomButtonsEP.map((el) => el.value);
    const mpButtons = extraBottomButtonsMP.map((el) => el.value);

    if (!conditionToShowExtraButton(epButtons, mpButtons)) return null;

    if (mpButtons.includes(selectedStake)) {
      return (
        <div className={styles.extraButtonsWrapper}>
          {
            extraBottomButtonsMP.map((el) => (
              <button
                type="button"
                className={`${styles.cell} ${selectedStake === el.value ? styles.selectedStake : ''}`}
                key={el.value}
                onMouseOver={() => handlePercentShow(el.value)}
                onFocus={() => handlePercentShow(el.value)}
                onMouseOut={() => setPercents(extraPercents)}
                onBlur={() => setPercents(extraPercents)}
                onClick={() => {
                  handlePercentShow(el.value);
                  setStake(el.value);
                  setFirstPairCardTableFold(easyRFI, smartRange);
                }}
              >
                {el.label}
              </button>
            ))
          }
        </div>
      );
    }

    return (
      <div className={styles.extraButtonsWrapper}>
        {
          extraBottomButtonsEP.map((el) => (
            <button
              type="button"
              className={`${styles.cell} ${selectedStake === el.value ? styles.selectedStake : ''}`}
              key={el.value}
              onMouseOver={() => handlePercentShow(el.value)}
              onFocus={() => handlePercentShow(el.value)}
              onMouseOut={() => setPercents(extraPercents)}
              onBlur={() => setPercents(extraPercents)}
              onClick={() => {
                handlePercentShow(el.value);
                setStake(el.value);
                setFirstPairCardTableFold(easyRFI, smartRange);
              }}
            >
              {el.label}
            </button>
          ))
        }
      </div>
    );
  };

  return (
    <Card
      // height={getBreakpoints(matrixBreakpoints, 'height', width)
      //       * getBreakpoints(matrixBreakpoints, 'scale', width)}
      className={styles.tables}
    >
      <div className={styles.topButtonsWrapper}>
        <PressButton
          text="Easy RFI"
          handleClick={() => setEasyRFI(!easyRFI)}
          isChecked={easyRFI}
        />
        <PressButton
          text="Smart Range"
          handleClick={() => setSmartRange(!smartRange)}
          isChecked={smartRange}
        />
        {
          !isPlo5 && (
            <Toggler
              className={styles.selectGgpsWrapper}
              selected={ggps}
              options={[{ label: 'PS', value: 'ps' }, { label: 'GG', value: 'gg' }, { label: 'MTT', value: 'mtt' }, { label: 'HU', value: 'hu' }]}
              onToggle={(e) => changeGgpsHandler(e.value)}
              use="red"
            />
          )
        }
        {
          isPlo5
            && (
            <Toggler
              className={styles.selectGgpsWrapper}
              selected={gameTable}
              options={[{ label: '6MAX', value: '6max' }, { label: 'HU', value: 'hu' }]}
              onToggle={(e) => changeGameTableHandler(e.value)}
              use="red"
              disabled={selectedTable !== 1 || rate}
            />
            )
        }
      </div>
      <div className={styles.tableControls}>
        <div className={styles.chooseStake}>
          <div className={styles.selectTsWrapperRakeStr}>
            <Toggler
              className={styles.fullWidth}
              selected={selectedTs}
              options={getTsSelectorOptions()}
              onToggle={changeTsHandler}
              use="red"
              disabled={rate}
            />
          </div>
          <Toggler
            className={styles.selectTsWrapper}
            selected={selectedBB}
            options={tsSelectorToggler(selectedTs)}
            onToggle={(e) => changeTableData(e)}
            use="red"
            disabled={selectedTable !== 1 || rate}
            selectedTSisAnte={['ante', 'ante3_5x', 'straddle', 'straddle3x'].includes(selectedTs)}
            selectedTsIsMedium={selectedTs === 'low'}
            selectedGameTableIsHU={gameTable === 'hu'}
          />
        </div>
        <div className={styles.breadCrumbWrapper}>
          <BreadCrumbs
            className={styles.tableBreadCrumbs}
            onClick={setSelectedTable}
            currentActiveTable={selectedTable}
            ts={selectedTs}
            stake={selectedStake}
            cards={selectedCards}
            isDoublesuit={suit === 'double'}
            setSuit={setSuit}
            selectedStakeIsRfi={selectedStake.includes('rfi') || selectedStake === 'sbnolimp' || (isPlo5 && (['ep', 'mp', 'co', 'bu', 'sb'].includes(selectedStake)))}
            easyRFI={easyRFI}
            isPlo5={isPlo5}
            ggps={ggps}
            setShowPercents={setShowPercents}
            setPercents={setPercents}
          />
          {(selectedTable === 4 && suit !== 'double' && !isPlo5) && (
            <section className={styles.switchesWrapper}>
              <div className={styles.switchWrapper}>
                <Switch
                  isOn={suit === 'rainbow'}
                  handleToggle={() => handleRainbow()}
                />
                <P className={styles.switchName}>Rainbow</P>
              </div>
              {(selectedCards[0] !== selectedCards[1]) && (
              <div className={styles.switchWrapper}>
                <Switch
                  isOn={suit === 'mono'}
                  handleToggle={() => handleMono()}
                />
                <P className={styles.switchName}>Mono</P>
              </div>
              )}
            </section>
          )}
          {(selectedTable === 4 && suitQuality !== 'double' && isPlo5 && selectedCardsAreUniq()) && (
            <section className={styles.switchesWrapper}>
              {(selectedCards[0] !== selectedCards[1]) && (
              <div className={styles.switchWrapper}>
                <Switch
                  isOn={suit === 'mono'}
                  handleToggle={() => handleMono()}
                />
                <P className={styles.switchName}>Mono</P>
              </div>
              )}
            </section>
          )}
          <HandlerPercents percentsOptions={percents} />
        </div>
      </div>
      <Preloader isLoading={isSituationLoading}>
        <div className={styles.matrixArea}>
          <div
            style={{
              height: `${getBreakpoints(matrixBreakpoints, 'height', width)
              * getBreakpoints(matrixBreakpoints, 'scale', width)}px`,
            }}
            className={styles.matrix}
          >
            <div
            // fixMe
            // style={{ width: width < 640 ? width : 'auto' }}
              className={styles.firstTable}
            >
              {selectedTable === 1
            && (
              <Card
                use="transparent"
                scale={`scale(${getBreakpoints(matrixBreakpoints, 'scale', width)})`}
                className={styles.situationWrapper}
              >
                <div
                  style={{ width: width < 640 ? width - 10 : 'auto' }}
                  className={styles.situationTable}
                >
                  <SituationTable
                    setPercents={setPercents}
                    onSetStake={setStake}
                    setSelectedTable={setSelectedTable}
                    tableData={situationFilterByBB()}
                    easyRFI={easyRFI}
                    setEasyRFI={setEasyRFI}
                  />
                </div>
              </Card>
            )}
              {selectedTable === 2
            && (
              <CardTable
                setSelectedTable={setSelectedTable}
                onSetCard1={setCard1}
                onSetCard2={setCard2}
                onSetSuit={setSuit}
                setTable={setTable}
                bbAndStake={bbAndStake}
                selectedStake={selectedStake}
                firstPairCardTableFold={firstPairCardTableFold}
                setFirstPairCardTableFold={setFirstPairCardTableFold}
                isFirstPairCardTableFoldLoaded={isFirstPairCardTableFoldLoaded}
                easyRFI={easyRFI}
                isPlo5={isPlo5}
                isFirstPairSelector
                selectedCards={selectedCards}
                setSuitQuality={setSuitQuality}
                smartRange={smartRange}
                setShowPercents={setShowPercents}
              />
            )}
              {selectedTable === 3
              && (
                <CardTable
                  setSelectedTable={setSelectedTable}
                  onSetCard1={setCard3}
                  onSetCard2={setCard4}
                  onSetSuit={setSuit}
                  setTable={setTable}
                  bbAndStake={bbAndStake}
                  selectedStake={selectedStake}
                  firstPairCardTableFold={secondPairCardTableFold}
                  setFirstPairCardTableFold={setSecondPairCardTableFold}
                  isFirstPairCardTableFoldLoaded={isSecondPairCardTableFoldLoaded}
                  easyRFI={easyRFI}
                  isPlo5={isPlo5}
                  isFirstPairSelector={false}
                  selectedCards={selectedCards}
                  setSuitQuality={setSuitQuality}
                  isDoublesuit={suit === 'double'}
                  smartRange={smartRange}
                  setShowPercents={setShowPercents}
                />
              )}
              {selectedTable === 4
            && (
              <LastTable
                selectedCards={selectedCards}
                isTableLoaded={isTableLoaded}
                combination={combination}
                isDoublesuit={suit === 'double'}
                isRainbow={suit === 'rainbow'}
                isMono={suit === 'mono'}
                easyRFI={easyRFI}
                selectedStakeIsRfi={selectedStake.includes('rfi') || selectedStake === 'sbnolimp' || (isPlo5 && (['ep', 'mp', 'co', 'bu', 'sb'].includes(selectedStake)))}
                isPlo5={isPlo5}
                highestCard={highestCard}
                suitQuality={suitQuality}
              />
            )}
            </div>
          </div>
          {sideAction ? <div className={styles.sideAction}>{sideAction}</div> : null}
        </div>
        {extraButtonsHandler()}
      </Preloader>
    </Card>
  );
};
export default React.memo(MatrixTable);
